export default __webpack_public_path__ + "static/media/addFile.96233c3b.svg";